import stringify from "json-stable-stringify";
import moment from "moment-timezone";

/**
 * @param {String} startDate
 * @param {String} endDate
 * @param {String} [previousPeriodStartDate]
 * @param {String} [previousPeriodEndDate]
 * @returns {String}
 */
export function getDateRangeLabel(
  startDate,
  endDate,
  previousPeriodStartDate,
  previousPeriodEndDate
) {
  let dateRangeTitle = startDate === endDate
    ? moment(startDate)
      .format("MMM D, YYYY")
    : `${
      moment(startDate)
        .format("MMM D, YYYY")
    } – ${
      moment(endDate)
        .format("MMM D, YYYY")
    }`;

  if (previousPeriodStartDate && previousPeriodEndDate) {
    dateRangeTitle += ` vs ${
      previousPeriodStartDate === previousPeriodEndDate
        ? moment(previousPeriodStartDate)
          .format("MMM D, YYYY")
        : `${
          moment(previousPeriodStartDate)
            .format("MMM D, YYYY")
        } – ${
          moment(previousPeriodEndDate)
            .format("MMM D, YYYY")
        }`
    }`;
  }

  return dateRangeTitle;
}

/**
 *
 */
export class AnalyticsRequestParams {
  /**
   * @param {AnalyticsRequestParams.Filter} filter
   */
  constructor({ filter }) {
    /** @type AnalyticsRequestParams.Filter */
    this.filter = filter;
  }

  /**
   * @returns {Number}
   */
  get periodLengthDays() {
    return moment(this.filter.endDate).diff(moment(this.filter.startDate), "days");
  }

  /**
   * @returns {AnalyticsRequestParams}
   */
  get previousPeriod() {
    return new this.constructor({
      filter: this.constructor.Filter({
        ...this.filter.toObject(),

        startDate: moment(this.filter.startDate)
          .subtract(this.periodLengthDays + 1, "day")
          .format("YYYY-MM-DD"),

        endDate: moment(this.filter.startDate)
          .subtract(1, "day")
          .format("YYYY-MM-DD")
      })
    });
  }

  /**
   * @returns {Array.<String>}
   */
  get allowedUnitValues() {
    const { periodLengthDays } = this;

    if (periodLengthDays < 6) {
      return ["day"];
    }

    if (periodLengthDays < 28) {
      return ["day", "week"];
    }

    if (periodLengthDays > 180) {
      return ["week", "month"];
    }

    return ["day", "week", "month"];
  }

  /**
   * @param {Boolean} [shouldRequestPreviousPeriod=false]
   * @returns {String}
   */
  getDateRangeLabel(shouldRequestPreviousPeriod = false) {
    if (shouldRequestPreviousPeriod) {
      const previousPeriodParams = this.previousPeriod;

      return getDateRangeLabel(
        this.filter.startDate,
        this.filter.endDate,
        previousPeriodParams.filter.startDate,
        previousPeriodParams.filter.endDate
      );
    }

    return getDateRangeLabel(
      this.filter.startDate,
      this.filter.endDate
    );
  }

  /**
   * @param {AnalyticsRequestParams} analyticsRequestParams
   * @returns {Boolean}
   */
  isEqual(analyticsRequestParams) {
    return stringify(this) === stringify(analyticsRequestParams);
  }
}
